import React, {Component} from 'react'
import { change, Field, reduxForm, reset} from 'redux-form';
import { isFloat, isInteger, renderAutoCompleteSingleSelect, renderDateField, renderTextField } from '../../../../../../components/reduxFields';
import { getMasterData, getDailySummaryDomainList, getDailySummaryProgramList, getDailySummaryTargetList,getBehaviorList, getDailySummaryData, getDailySummaryBehaviorData, updateDailySummarySkillAcquistionData,updateDailyBehaviorData } from './actions/DailySummaryDataActions';
import { updateSkillAcqCollectedTADataPromtCodeAction, updateSkillAcqCollectedDTTDataPromtCodeAction, updateCollectedSkillAquisitionBehaviorDataForTodaysData} from '../../../DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions';
 import { RaisedButton } from 'material-ui';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Alert from 'react-s-alert';
import TextField from 'material-ui/TextField';
import moment from 'moment';
import uuid from "uuid";
import GlobalVariables, { showFormatedDate } from '../../../../../../actions/utilAction';
import PaginatorCustom from '../../../../../../components/paginationCustom';
import SortingCustom from '../../../../../../components/SortingCustom';
import { delay } from 'lodash';



const normalizeMaxValue = (max) => (value) => {
  if (!value) return value;
  const num = Number(value);
  return num > max ? String(max) : value; // Restrict input beyond max
};

const roundToTwoDecimals = (value) => {
  if (!value) return value;
  return parseFloat(value).toFixed(2); // Round to 2 decimal places
};


class DailySummaryData extends Component {
  
    constructor(props){
        super(props);
        this.state = {
            selectedTargetType : null,
            selectedTargetStatus : null,
            selectedBehaviorType : null,
            selectedDomain: null,
            selectedProgram : null,
            selectedTarget : null, 
            selectedBehavior : null,
            domainId : null,
            recordingTypeId : null,
            Date: new Date(), 
            currentPageSkillAcquisition: 1, 
            currentPageBehavior: 1,
            decimalErrors: {},
            inputError : {}
        }

        this.filter = {
          sort_Column: 'id',
          sort_Order: 'desc',
          searchText: '',
        };

        this.handleFilter = this.handleFilter.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.loadData = this.loadData.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.setSortBehaviorColumn =this.setSortBehaviorColumn.bind(this);
        this.getSkillAcquisitionData = this.getSkillAcquisitionData.bind(this);
        this.getBehaviorData = this. getBehaviorData.bind(this);
    }

    createSearchObj = (page_number) =>{ 
      return{
        sort_fields: this.filter.sort_Column || 'id',
        sort_order: this.filter.sort_Order || 'desc',
        // contain_filters: { SearchText: this.filter.searchText || null },
        pageNumber: page_number || 1,
      }
    };

    loadData(page_number){
        const searchObj = this.createSearchObj(page_number);

        this.props.getDailySummaryDomainList(searchObj,this.props.patientId, true);
        this.props.getDailySummaryProgramList(searchObj,this.props.patientId,0, true);
        this.props.getDailySummaryTargetList(searchObj,this.props.patientId,0, true,null);
        this.props.getBehaviorList(searchObj,this.props.patientId,true);
        this.getSkillAcquisitionData(searchObj)
        this.getBehaviorData(searchObj)
    }


    getSkillAcquisitionData(page_number){
      this.setState({currentPageSkillAcquisition: page_number})
      let searchObj = {
        sort_fields: this.filter.sort_Column || 'id',
        sort_order: this.filter.sort_Order ||'desc',
        contain_filters: {
          patientId:  this.props.patientId,
          skillAcquisitionDomainId: this.state.selectedDomain ? this.state.domainId : 0,
          skillAcquisitionProgramId: this.state.selectedProgram ? this.state.selectedProgram.value : 0,
          skillAcquisitionTargetId: this.state.selectedTarget ? this.state.selectedTarget.value : 0,      
          TargetTypeId: this.state.selectedTargetType ? this.state.selectedTargetType : '',
          TargetStatusId: this.state.selectedTargetStatus ? this.state.selectedTargetStatus : '',
          Date: this.state.Date ? moment(this.state.Date).format('YYYY-MM-DD') : new Date(),
        },
        pageNumber: page_number ? page_number : 1,
        pageSize: GlobalVariables.PageSize,
      };
      
      this.props.getDailySummaryData(searchObj);
    }

    getBehaviorData (page_number){
      this.setState({currentPageBehavior: page_number})
      let searchObj = {
        contain_filters: {
          patientId:  this.props.patientId,
          behaviorsReductionId : this.state.selectedBehavior ? this.state.selectedBehavior.value : 0,
          recordingTypeId : this.state.selectedBehaviorType ? this.state.selectedBehaviorType : '',
          Date: this.state.Date ? moment(this.state.Date).format('YYYY-MM-DD') : new Date(),
        },
        sort_fields: this.filter.sort_Column || 'id',
        sort_order: this.filter.sort_Order || 'desc',
        pageNumber: page_number || 1,
      };
      this.props.getDailySummaryBehaviorData(searchObj)
    }

    setSortColumn(col_name, col_order) {
      if (col_name) {
        this.filter.sort_Column = col_name;
        this.filter.sort_Order = col_order;
        this.getSkillAcquisitionData()
      }
    }

    setSortBehaviorColumn(col_name, col_order) {
      if (col_name) {
        this.filter.sort_Column = col_name;
        this.filter.sort_Order = col_order;
        this.getBehaviorData();
      }
    }

    componentWillMount() {                   
        this.loadData();
        let masterData = { 'masterdata': 'MASTERTARGETTYPE,TARGETSTATUS,MASTERRECORDINGTYPES'};   
        this.props.getMasterData(masterData);

    }

    setSortColumn(col_name, col_order) {
      if (col_name) {
        this.filter.sort_Column = col_name;
        this.filter.sort_Order = col_order;
        this.getSkillAcquisitionData()
      }
    }

    setSortBehaviorColumn(col_name, col_order) {
      if (col_name) {
        this.filter.sort_Column = col_name;
        this.filter.sort_Order = col_order;
        this.getBehaviorData();
      }
    }

    componentWillReceiveProps(nextProps){
      if (nextProps.dailySummaryData)
        {
            (nextProps.dailySummaryData || []).forEach((obj, index) => 
            {
             this.props.dispatch(change('DailySummaryDataForm', `Target[${index}].value`, obj.value));
            });
        }

      if(nextProps.dailySummaryBehaviorData) {
        (nextProps.dailySummaryBehaviorData || []).forEach((obj, index) => 
        {
         this.props.dispatch(change('DailySummaryDataForm', `Target2[${index}].value`, obj.value));
        });
    }

      }

    handleDomainNameSelection = (input, selected,page_number) =>{
      const searchObj = this.createSearchObj(page_number);
      const selectedDomainObj = this.props.domainList.find(domain => domain.id === selected.value);
      const domainId = selectedDomainObj ? selectedDomainObj.domainId : null;
        input.onChange(selected.value);
        this.setState({selectedDomain:selected , domainId : domainId}, () => {
          this.props.getDailySummaryProgramList(searchObj,this.props.patientId, domainId,true);
          this.props.getDailySummaryTargetList(searchObj,this.props.patientId, domainId,true, "DOMAIN",null);
        })
    }
    handleProgramNameSelection = (input, selected,page_number) =>{
      const searchObj = this.createSearchObj(page_number);
        input.onChange(selected.value);
        this.setState({selectedProgram:selected}, () => {
          this.props.getDailySummaryTargetList(searchObj,this.props.patientId, selected.value,true, "PROGRAM",this.state.domainId);
        })
    }
    
    handleTargetNameSelection = (input, selected) =>{
      input.onChange(selected.value);
     this.setState({selectedTarget: selected});
    }

    handleTargetTypeSelection = (input, selected) =>{
        input.onChange(selected.value);
        this.setState({selectedTargetType:selected.value});
    }

    handleTargetStatusSelection = (input, selected) =>{
        input.onChange(selected.value);
        this.setState({selectedTargetStatus:selected.value});
    }

    handleBehaviorNameSelection = (input, selected,page_number) => {
      const searchObj = this.createSearchObj(page_number);
      const selectedBehaviorObj = this.props.behaviorName.find(behavior => behavior.id === selected.value);
      const recordingTypeId = selectedBehaviorObj ? selectedBehaviorObj.recordingTypeId : null;
      input.onChange(selected.value);
      this.setState({selectedBehavior : selected, recordingTypeId :recordingTypeId}, () =>{
        this.props.getBehaviorList(searchObj,this.props.patientId,true);
      })
    }
    
    handleBehaviorTypeSelection = (input, selected) => {
        input.onChange(selected.value);
        this.setState({selectedBehaviorType:selected.value});
    }

    handleValueChange = async(event, data,index) => {
      let SkillAquisitionData = this.props.dailySummaryData
      let value = event.target.value;
      if(SkillAquisitionData[index].value!==Number(value)){
        let Date=this.state.Date ? moment(this.state.Date).format('YYYY-MM-DD') : new Date()
        try{
          await this.props.updateDailySummarySkillAcquistionData(data.skillsAcquisitionTargetId,value,Date)
          delay(()=> this.getSkillAcquisitionData(this.state.currentPageSkillAcquisition),200)
         
        }catch(e){
          console.log("error....",e)
        }
      }
     
    }

    handleBehaviorValueChange = async(event, data,index) => {
      let BehaviorData = this.props.dailySummaryBehaviorData
      this.setState({ decimalErrors: false, inputError: false });
      let value = event.target.value;
      if(BehaviorData[index].value!==Number(value)){
        let Date=this.state.Date ? moment(this.state.Date).format('YYYY-MM-DD') : new Date()
        try{
          await this.props.updateDailyBehaviorData(data.behaviorReductionId , value,Date)
          delay(()=> this.getBehaviorData(this.state.currentPageBehavior),200)
        }catch(e){
          console.log("error....",e)
        }
      }
     
    } 

    handleControlInput = (event,data,index) => {
      let value = event.target.value;
      let errorMessage = "";
      if (data.recordingType === "DTT" || data.recordingType === "Task Analysis") {
        if (value > 100) {
          errorMessage = `The value for ${data.recordingType} cannot exceed 100%`;
        }
      }else if (data.recordingType === "Frequency") {
        if(value > 999)
        errorMessage = `The value for ${data.recordingType} cannot exceed 999`;
      }else if (data.recordingType === "Duration") {
        if(value > 240)
          errorMessage = `The value for ${data.recordingType} cannot exceed 240mins`;
      }
    }

    handleDecimalPoint = (index, e) => {
      const { value } = e.target;
  
      // Check if the value is empty or matches the decimal format
      if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
          // Count the number of decimal points
          const decimalPoints = (value.match(/\./g) || []).length;
  
          // Allow only up to one decimal point
          if (decimalPoints <= 1) {
              this.setState(prevState => ({
                  decimalErrors: {
                      ...prevState.decimalErrors,
                      [index]: false // No error for this field
                  }
              }));
              return;
          }
      }
  
      // Show error if there are multiple decimal points
      this.setState(prevState => ({
          decimalErrors: {
              ...prevState.decimalErrors,
              [index]: true // Error for this field
          }
      }));
  };
  

    onDateChange = (input, value)=> {
      input.onChange(moment(value).format());
      this.setState({ [input.name]: value });
    }

    handleFilter = (event = {}) =>{
      const eventDate = event.Date ? showFormatedDate(event.Date) : new Date();
  
      this.setState({
        Date: eventDate
      }, () => {
        this.getSkillAcquisitionData();
        this.getBehaviorData();
      })
    }

    handleReset = () => {
      this.props.dispatch(reset('DailySummaryDataForm'));
       this.setState({
           selectedTargetType:null,
           selectedDomain: null,
           selectedProgram: null,
           selectedTarget: null,
           selectedType: null,
           selectedTargetStatus: null,
           selectedBehavior : null,
           selectedBehaviorType : null,
           Date : new Date(),
         }, () => {     
            // this.props.dispatch(change("DailySummaryDataForm", "targetType", null));
            // this.handleFilter();
            this.getSkillAcquisitionData();
            this.getBehaviorData();
            
       });
       this.loadData()
     }

    renderData(getDailySummaryBehaviorDataList) {
      getDailySummaryBehaviorDataList = getDailySummaryBehaviorDataList || [];
      if (!getDailySummaryBehaviorDataList.length) {
          return (
              <tr> 
                  <td colSpan="12">
                      <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                  </td>
              </tr>
          );
      }
      return getDailySummaryBehaviorDataList.map((Obj, index) => {
        let normalizeFn;
        let maxLimit;
        let recordingTypeName = String(Obj.recordingTypeName).trim();

        if (recordingTypeName === "Frequency") {
          maxLimit = 999;
          normalizeFn = (value) => {
            return normalizeMaxValue(maxLimit)(isInteger(value));
          };
        } else if (recordingTypeName === "Duration") {
          maxLimit = 240.00;
          normalizeFn = (value) => {
            return normalizeMaxValue(maxLimit)(isFloat(value));
          };
        } else if (recordingTypeName === "Momentary Time Sample") {
          maxLimit = 100.00;
          normalizeFn = (value) => {
            return normalizeMaxValue(maxLimit)(isFloat(value));
          };

        } else if (recordingTypeName === "Partial Interval") {
          maxLimit = 100.00;
          normalizeFn = (value) => {
            return normalizeMaxValue(maxLimit)(isFloat(value));
          };

        } else if (recordingTypeName === "Rate") {
          maxLimit = 999.99;
          normalizeFn = (value) => {
            return normalizeMaxValue(maxLimit)(isFloat(value));
          };
        } else {
          normalizeFn = (value) => {
            return isInteger(value); // Default case
          };
        }

        return(
          <tr key={index}>
          <td width="20%">{Obj.behaviorName}</td>
          <td width="20%">{Obj.recordingTypeName}</td>
          <td width="10%">
          <Field
            name={`Target2[${index}].value`}
            type="text"
            maxLength={Obj.recordingTypeName==="Duration" || Obj.recordingTypeName==="Partial Interval" || Obj.recordingTypeName==="Rate" || Obj.recordingTypeName==="Momentary Time Sample"?"6":"4"}
            component={renderTextField}
            // normalize={Obj.recordingTypeName==="Duration" || Obj.recordingTypeName==="Partial Interval" || Obj.recordingTypeName==="Momentary Time Sample"?isFloat:isInteger}
            normalize={normalizeFn}
            disabled={this.props.updatePermissionAddEditSummary ? false : true}
            onBlur={(event) => this.handleBehaviorValueChange(event, Obj,index)}
            // onKeyPress={(e) => {
            //   // Allow only 0, 1, and control keys
            //   if(Obj.recordingTypeName==="Partial Interval" || Obj.recordingTypeName==="Momentary Time Sample"){
                
            //     if (!/[01]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
            //       e.preventDefault();
            //     }
            //   }
            // }}
            onChange={(e) => {
              if(Obj.recordingTypeName==="Duration" || Obj.recordingTypeName==="Partial Interval" || Obj.recordingTypeName==="Momentary Time Sample"){
                this.handleDecimalPoint(index, e);
              }
              // else if(){
              //   // const value = e.target.value;
              //   // if (value && value !== "0" && value !== "1") {
              //   //   e.target.value = ""; // Clear the input if invalid
              //   // }
              //   this.handleControlInput(index,e)
              // }
            }}
          />
          <p>{this.state.decimalErrors[index] ? <span style={{ color: "rgb(244, 67, 54)", fontSize: "12px" }}>Invalid decimal number</span> : null}</p>
          {/* <p>{this.state.inputError[index]? <span style={{ color: "rgb(244, 67, 54)", fontSize: "12px" }}>Please enter a value 0 or 1 </span> : null}</p> */}
          </td>
          {Obj.recordingTypeName==="Rate"?<td width={"10%"}><h6>Rate Per 5 Min</h6></td>:null}
          
      </tr>
        )
      })
    }

  renderSkillAcquisitionData = (dailySummaryData)=>{  
    dailySummaryData= dailySummaryData || [];
    if (!dailySummaryData.length) {
        return (
            <tr> 
                <td colSpan="12">
                    <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                </td>
            </tr>
        );
        
    }

    return dailySummaryData.map((Obj, index) => {
      let normalizeFn;
      let maxLimit;

      if (Obj.recordingType === "Frequency") {
        maxLimit = 999;
        normalizeFn = (value) => normalizeMaxValue(maxLimit)(isInteger(value));
      } else if (Obj.recordingType === "Duration") {
        maxLimit = 240.00;
        normalizeFn = (value) =>
          normalizeMaxValue(maxLimit)(isFloat(value));
      } else if (Obj.recordingType === "Rate") {
        maxLimit = 999.99;
        normalizeFn = (value) =>
          normalizeMaxValue(maxLimit)(isFloat(value));
      } else if (Obj.recordingType === "DTT") {
          maxLimit = 100.00;
          normalizeFn = (value) =>
            normalizeMaxValue(maxLimit)(isFloat(value));
        } else if (Obj.recordingType === "TA") {
          maxLimit = 100.00;
          normalizeFn = (value) =>
            normalizeMaxValue(maxLimit)(isFloat(value));

        } else {
          normalizeFn = (value) => isFloat(value); // Default case
        }

      return(
        <tr key={index}>
            <td width="20%">{Obj.domainName}</td>
            <td width="12%">{Obj.programName}</td>
            <td width="10%">{Obj.targetName}</td>
            <td width="12%">{Obj.recordingType}</td>
            <td width="12%">{Obj.status}</td>
            <td width="12%">
              <Field
                name={`Target[${index}].value`}
                type="text"
                maxLength={Obj.recordingType==="Duration" || Obj.recordingType==="Rate" || Obj.recordingType==="Momentary Time Sample" || Obj.recordingType==="DTT" || Obj.recordingType==="TA"?"6":"4"}
                component={renderTextField}
                // normalize={Obj.recordingType==="Frequency"?isInteger:isFloat}
                // normalize={Obj.recordingType === "Frequency" ? (value) => normalizeMaxValue(999)(isInteger(value)) : isFloat }
                normalize={normalizeFn}
                disabled={this.props.updatePermissionAddEditSummary? false : true}
                onBlur={(event) => this.handleValueChange(event, Obj,index)}
                onChange={(event) => {
                  this.handleControlInput(event, Obj, index)
                }}
              />
              <p>{this.state.inputError[index]? <span style={{ color: "rgb(244, 67, 54)", fontSize: "12px" }}>{this.state.inputError[index]}</span> : null}</p>
            </td>
        </tr>
      )
    })
  }

    render(){
        const {handleSubmit , dailySummaryData , dailySummaryBehaviorData,dailySummaryDataMeta,dailySummaryBehaviorDataMeta} = this.props;
        let dailySummaryDataList = (dailySummaryData && dailySummaryData.summaryData) || [];
        let getDailySummaryBehaviorDataList = dailySummaryBehaviorData || [];
        let dailySummaryBehaviorMetaData = (dailySummaryBehaviorDataMeta && dailySummaryBehaviorDataMeta) || null;
        let dailySummarySkillMetaData = (dailySummaryDataMeta && dailySummaryDataMeta)
        const tableClass = classNames({
            'table': true,
            'tableAuditLog': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });

        return(
            <div>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleFilter)}>
                            <div className="row">
                              <div className="col-sm-2 mt-15">Date:</div>
                              <div className="col-sm-4">
                                <Field 
                                  name="Date"
                                  locale="en-US"
                                  selected={this.state.Date || new Date()}
                                  onDateChange={this.onDateChange}
                                  openToYearSelection={true}
                                  component={renderDateField} 
                                  maxDate={new Date()}/>
                              </div>
                              </div>
                            <div className="row mtm-20">
                                <div className="col-sm-4 insfield mt-35">
                                    <Field
                                        autoFocus={true}
                                        name="domainName"
                                        label="Domain Name"
                                        handleNewRequest={this.handleDomainNameSelection}
                                        options={this.props.domainList}
                                        component={renderAutoCompleteSingleSelect} 
                                    />
                                </div>
                                <div className="col-sm-4 insfield mt-35">
                                    <Field
                                    name="programName"
                                    label="Program Name"
                                    handleNewRequest={this.handleProgramNameSelection}
                                    options={this.props.programList}
                                    component={renderAutoCompleteSingleSelect} 
                                    />
                                </div>
                                <div className="col-sm-4 insfield mt-35">
                                    <Field
                                        name="targetName"
                                        label="Target Name"
                                        handleNewRequest={this.handleTargetNameSelection}
                                        options={this.props.targetList}
                                        component={renderAutoCompleteSingleSelect} 
                                    />
                                </div>
                            </div>
                            <div className="row mtm-20">
                              <div className="col-sm-4 insfield mt-35">
                                <Field
                                    name="targetType"
                                    label="Target Type"
                                    handleNewRequest={this.handleTargetTypeSelection}
                                    options={this.props.targetType}
                                    component={renderAutoCompleteSingleSelect}
                                />
                               </div>
                              <div className="col-sm-4 insfield mt-35">
                                <Field
                                    name="targetStatus"
                                    label="Target Status"
                                    handleNewRequest={this.handleTargetStatusSelection}
                                    options={this.props.targetStatus}
                                    component={renderAutoCompleteSingleSelect} 
                                />
                               </div>
                            </div>
                            <div className="row mtm-20">
                              <div className="col-sm-4 insfield mt-35">
                                <Field
                                    name="behaviorName"
                                    label="Behavior Name"
                                    handleNewRequest={this.handleBehaviorNameSelection}
                                    options={this.props.behaviorName}
                                    component={renderAutoCompleteSingleSelect} 
                                />
                               </div>
                              <div className="col-sm-4 insfield mt-35">
                                <Field
                                    name="behaviorType"
                                    label="Behavior Type"
                                    handleNewRequest={this.handleBehaviorTypeSelection}
                                    options={this.props.behaviorType}
                                    component={renderAutoCompleteSingleSelect} 
                                />
                               </div>
                            </div>
                            <div className="row">
                                <div className="col-8 col-sm-8 col-md-8" style={{fontSize: "13px"}}>
                                  <span>
                                    Note: Adding data collected here will displayed on the following graphs
                                  </span>
                                  <ul style={{paddingLeft: "1rem"}}>
                                    <li>%Correct Responding</li>
                                    <li>%Correct Steps</li>
                                    <li>Steps Performance</li>
                                  </ul>
                                </div>
                                <div className="col-4 col-sm-4 col-md-4 btn_rt reset-btn claims_filter">
                                    <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                                    <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>                      
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                  <h2 className="page_title mt-25">Skill Acquisition</h2>
                    <div className="table-responsive mt-15">

                    <table className={tableClass}>

                          <thead>
                          <tr>
                              {/* <th  width="5%"></th>    */}
                              <th width="20%">
                                <SortingCustom  setSortColumn={this.setSortColumn} columnName='DomainName' displayName='Domain' />
                              </th>
                              <th width="12%">
                                <SortingCustom  setSortColumn={this.setSortColumn} columnName='ProgramName' displayName='Program' />
                              </th>
                              <th width="10%">
                                <SortingCustom  setSortColumn={this.setSortColumn} columnName='TargetName' displayName='Target' />
                              </th>
                              <th width="12%">
                                <SortingCustom  setSortColumn={this.setSortColumn} columnName='RecordingType' displayName='Recording Type' />
                              </th>
                              <th width="12%">
                                <SortingCustom  setSortColumn={this.setSortColumn} columnName='Status' displayName='Status' />
                              </th>

                              <th width="12%">
                                <SortingCustom  setSortColumn={this.setSortColumn} columnName='value' displayName='Value' />
                              </th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {this.renderSkillAcquisitionData(dailySummaryData)}
                          </tbody>
                        </table>

                      {(dailySummarySkillMetaData &&  dailySummarySkillMetaData['totalPages']) ?
                        (<PaginatorCustom data={dailySummarySkillMetaData} handlePageChange={(page_number) => this.getSkillAcquisitionData(page_number)} />)
                        :
                        null
                      } 
                    </div>
                  </div>
                </div>
                <div className="row">
                 <div className="col-sm-12">
                    <h2 className="page_title mt-25">Behavior Reduction</h2>
                    <div className="table-responsive mt-15">

                        <table className={tableClass}>
                          <thead>
                          <tr>
                          <th width="20%"> 
                                <SortingCustom  setSortColumn={this.setSortBehaviorColumn} columnName='behaviorName' displayName='Behavior' />
                              </th>
                              <th width="12%">
                                <SortingCustom  setSortColumn={this.setSortBehaviorColumn} columnName='recordingTypeName' displayName='Behavior Type' />
                              </th>
                              <th width="10%">
                                <SortingCustom  setSortColumn={this.setSortBehaviorColumn} columnName='value' displayName='Value' />
                              </th>
                              <th width = "10%"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.renderData(getDailySummaryBehaviorDataList)}
                          </tbody>
                        </table>              
                         
                      {dailySummaryBehaviorMetaData && dailySummaryBehaviorMetaData['totalPages']?
                        <PaginatorCustom data={dailySummaryBehaviorMetaData} handlePageChange={(page_number) => this.getBehaviorData(page_number)} />
                        :
                        null
                      } 
                    </div>
                 </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state){
    return{
        loading : state.patientDailySummaryData.loading,
        behaviorType :state.patientDailySummaryData.masterData ? state. patientDailySummaryData.masterData.masterRecordingTypes : [],
        targetType:state.patientDailySummaryData.masterData ? state. patientDailySummaryData.masterData.targetType : [],
        targetStatus:state.patientDailySummaryData.masterData ? state. patientDailySummaryData.masterData.targetStatus : [],
        domainList : state.patientDailySummaryData.dailySummaryDataDomainList ? state.patientDailySummaryData.dailySummaryDataDomainList.data : [],
        programList : state.patientDailySummaryData.dailySummaryDataProgramList ? state.patientDailySummaryData.dailySummaryDataProgramList.data : [],
        targetList :  state.patientDailySummaryData.dailySummaryDataTargetList ?state.patientDailySummaryData.dailySummaryDataTargetList.data : [],
        behaviorName : state.patientDailySummaryData.behaviorList ? state.patientDailySummaryData.behaviorList.data : [],
        dailySummaryData : state.patientDailySummaryData.getDailySummaryData ?state.patientDailySummaryData.getDailySummaryData.data : [],
        dailySummaryBehaviorData :state.patientDailySummaryData.getDailySummaryBehaviorData ? state.patientDailySummaryData.getDailySummaryBehaviorData.data : [],
        dailySummaryBehaviorDataMeta :state.patientDailySummaryData.getDailySummaryBehaviorData ? state.patientDailySummaryData.getDailySummaryBehaviorData.meta : [],
        dailySummaryDataMeta : state.patientDailySummaryData.getDailySummaryData ?state.patientDailySummaryData.getDailySummaryData.meta : [],
        updateDailySummarySkillAcquisition : state.patientDailySummaryData.updateDailySummarySkillAcquisitionData ?  state.patientDailySummaryData.updateDailySummarySkillAcquisitionData : [],
    }
}

DailySummaryData = reduxForm({
    form: 'DailySummaryDataForm',
    enableReinitialize: true,
  })(DailySummaryData);

export default connect(mapStateToProps, {getMasterData, getDailySummaryDomainList, getDailySummaryProgramList, getDailySummaryTargetList, getBehaviorList, getDailySummaryData, getDailySummaryBehaviorData, updateDailySummarySkillAcquistionData,updateDailyBehaviorData})(DailySummaryData);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/DailySummaryData/index.js